import { getType } from 'typesafe-actions'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { AxiosResponse } from 'axios'

import { getCountryCode } from '../config/selectors'
import { withLoading } from '../loading'
import { apiCall } from '../../utils/api'
import { waitForConfigLoad } from '../../utils/sagaUtils'

import { SearchCompaniesResponse } from './types'
import { SearchActions } from './actions'

export function* loadSearchData(action: ReturnType<typeof SearchActions.loadSearchData>) {
  yield call(waitForConfigLoad)

  const { filter, query, page, pageSize, countryFilter, preferredProduct } = action.payload

  const countryCode: string = yield select(getCountryCode)

  try {
    const { data }: AxiosResponse<SearchCompaniesResponse> = yield call(apiCall, {
      url: '/api/Search',
      method: 'get',
      params: {
        countryCode: countryFilter ?? countryCode,
        domainCode: countryCode,
        filter: {
          type: filter,
          value: query
        },
        page,
        pageSize,
        productCode: preferredProduct
      }
    })

    const { totalCount, pageCount } = data.meta
    const { companies } = data.data

    yield put(SearchActions.setLoadedCompanies({ companies, pageCount, pageSize, totalCount }))
  } catch {
    yield put(
      SearchActions.setLoadedCompanies({
        companies: [],
        pageCount: 0,
        pageSize: pageSize,
        totalCount: 0
      })
    )
  }
}

/* istanbul ignore next */
export function* searchSagas() {
  yield all([takeLatest(getType(SearchActions.loadSearchData), withLoading('search', loadSearchData))])
}
